import {
  fetchV1COAs,
  searchV1COAs,
  createV1COA,
  fetchV1AssetOverview,
  makePaymentMethodV1,
} from "@/services/v1/accountAPIService";

export default {
  state: {
    coas: [],
    coa: null,
    coaPageSize: 5,
    totalCOACount: 0,
    searchCOAQuery: "",
    assetOverview: null,
  },
  getters: {
    coas: (state) => state.coas,
    coa: (state) => state.coa,
    paymentMethodCOA: (state) => {
      return state.coas.filter((coa) => coa.is_payment_method === true);
    },
    currentCOAPageSize: (state) => state.coaPageSize,
    totalCOACount: (state) => state.totalCOACount,
    searchCOAQuery: (state) => state.searchCOAQuery,
    assetOverview: (state) => state.assetOverview,
  },
  mutations: {
    SET_COAS(state, coas) {
      state.coas = coas;
    },
    SET_COA(state, coa) {
      state.coa = coa;
    },
    SET_COA_PAGE_SIZE(state, pageSize) {
      state.coaPageSize = pageSize;
    },
    SET_TOTAL_COA_COUNT(state, count) {
      state.totalCOACount = count;
    },
    SET_COA_SEARCH_QUERY(state, query) {
      state.searchCOAQuery = query;
    },
    SET_ASSET_OVERVIEW(state, assetOverview) {
      state.assetOverview = assetOverview;
    },
    UPDATE_COA(state, updatedData) {
      const index = state.coas.findIndex((c) => c.code === updatedData.code);
      if (index !== -1) {
        state.coas[index] = {
          ...state.coas[index],
          ...updatedData,
        };
      }
    },
  },
  actions: {
    async fetchCOAs(
      { commit },
      {
        account_type = "",
        account_sub_type = "",
        page = 1,
        pageSize = 5,
        supplier = "",
        customer = "",
        paymentMethod = null,
      } = {}
    ) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1COAs(
          page,
          pageSize,
          account_type,
          account_sub_type,
          supplier,
          customer,
          paymentMethod,
        );
        if (supplier || customer) {
          commit("SET_COA", response);
          return;
        }
        commit("SET_COAS", response.results);
        commit("SET_COA_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_COA_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching coas:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async searchCOAs(
      { commit },
      { query, page = 1, pageSize = 8, account_type = "" } = {}
    ) {
      commit("SET_COA_SEARCH_QUERY", query);
      try {
        const response = await searchV1COAs(
          query,
          page,
          pageSize,
          account_type
        );
        commit("SET_COAS", response.results);
        commit("SET_COA_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_COA_COUNT", response.count);
      } catch (error) {
        console.error("Error searching roles:", error);
      }
    },
    async addCOA({ commit }, coa) {
      try {
        const response = await createV1COA(coa);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`role create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message = error.response?.data?.message || "Failed to add COA.";
        return { success: false, message };
      }
    },
    async fetchAssetOverview({ commit }) {
      try {
        const response = await fetchV1AssetOverview();
        commit("SET_ASSET_OVERVIEW", response);
      } catch (error) {
        console.error("Error fetching asset overview:", error);
      }
    },
    async makePaymentMethod({ commit }, accountCode) {
      try {
        const response = await makePaymentMethodV1(accountCode);
        commit("UPDATE_COA", response);
        return { success: true, data: response };
      } catch (error) {
        console.error("Error while making payment method", error);
      }
    },
  },
};
